import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Content from "@ds-developer/content";
import PageHeader from "@ds-developer/page-header";
import React from "react";

import { MyBusinessProfileProps } from "./types";
import { useFeature } from "flagged";
import BusinessProfileUrl from "./components/MyDetails/BusinessProfileUrl";
import MyAwards from "./MyAwards/MyAwards";
import ProfileDetails from "./components/MyDetails/ProfileDetails";

const MyBusinessProfile: React.FC<MyBusinessProfileProps> = ({
  profileDetails,
}) => {
  const theme = useTheme();

  const awardsShouldShow = useFeature("showAwardsAADSEnabled");

  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Content>
      <PageHeader
        title="Manage my business profile"
        breadcrumbs={[
          { title: "Home", link: "/" },
          { title: "My business profile" },
        ]}
        subtitle="Here's what's happening with your business today"
      />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5} xl={3}>
          <Box paddingBottom={2}>
            {!isMobile && (
              <Typography
                component="p"
                variant="overline"
                color="textSecondary"
              >
                My details
              </Typography>
            )}
          </Box>

          <Box paddingBottom={2}>
            <BusinessProfileUrl profileUrls={profileDetails?.profileUrls} />
          </Box>

          <ProfileDetails {...profileDetails} />
        </Grid>
        {awardsShouldShow && (
          <Grid item xs={12} sm={7} xl={9}>
            <Box paddingBottom={2}>
              {!isMobile && (
                <Typography
                  component="p"
                  variant="overline"
                  color="textSecondary"
                >
                  Latest updates
                </Typography>
              )}
            </Box>

            <Box paddingBottom={2}>
              <MyAwards
                awards={profileDetails?.awards}
                loading={profileDetails?.loading}
              />
            </Box>
          </Grid>
        )}
      </Grid>
    </Content>
  );
};

export default MyBusinessProfile;
